import {$app, ReactComponent} from "../app"
import React, {createRef} from "react"
import {Button, Form, Input, Space, Spin} from "antd"
import FloatLabel from "../components/inputs/FloatLabel"
import App from "../app/App"
import {passwordCheck} from "../helpers/utils"

export default class AccountChangePasswordPage extends ReactComponent {
  formRef = createRef()

  state = {
    loading: false,
    input_password_value: '',
    password_valid: false,
  }

  async handleFormChangePassword() {

    void this.updateState({loading: true})

    try {
      const password = this.state.input_password_value

      if(!passwordCheck(password)) throw 'Heslo neodpovídá požadavkům.'


      const customer = await $app.$api({
        action: 'carecloud_user_api'
      })

      const {personal_information = {}} = customer

      await this.$api({
        action: 'carecloud_user_api',
        route: '',
        method: 'PUT',
        data: {
          password: password,
          customer: {
            personal_information: personal_information,
          }
        }
      })

      App.$toast('Heslo bylo úspěšně změněno!')

    } catch (error) {

      $app.handleError(error)
      console.log(error)

    } finally {

      void this.updateState({loading: false})

    }
  }

  handlePasswordCheck(password_value) {
    const password_valid = passwordCheck(password_value)

    void this.updateState({password_valid: password_valid})
  }

  render() {
    return (
      <>
        <section className="container centered full-height">
          <h1 className="main-title">Změna hesla</h1>

          <Form
            ref={this.formRef}
            className="pl-2 pr-2 mt-3"
            onFinish={() => {
              void this.handleFormChangePassword()
            }}
          >

            <Form.Item rules={[{
              required: true, message: 'Vyplňte prosím heslo.'
            }]}>
              <FloatLabel label="Nové heslo" value={this.state.input_password_value}>
                <Input.Password
                  size="large"
                  variant="underlined"
                  visibilityToggle={true}
                  className={`${this.state.password_valid ? 'status-success' : ''}`}
                  value={this.state.input_password_value} onChange={async (e) => {
                  await this.updateState({input_password_value: e.target.value})
                  this.handlePasswordCheck(this.state.input_password_value)
                }}
                />
              </FloatLabel>
              <p className="_grey-primary-text fs-small pt-1">Heslo musí mít minimálně 8 znaků, jedno velké písmeno a jednu číslici.</p>
            </Form.Item>


            <Space style={{marginTop: 20}} size={[18, 20]} direction="vertical" className="container full ta-center mb-3">
              <Button
                htmlType="submit"
                type="primary"
                block
                icon={<Spin spinning={this.state.loading}/>}
                className="btn btn-primary _secondary _primary-text">
                Uložit</Button>
            </Space>

          </Form>

        </section>
      </>

    )
  }
}